<section class="stepper">
  <header class="stepper__header">
    <div class="stepper-header">
      <div class="stepper-header__top">
        <button
          class="stepper-header__back-button"
          cdkStepperPrevious
          [class.stepper-header__back-button--hidden]="selectedIndex === 0"
        >
          <i class="material-icon"> keyboard_arrow_left </i>
        </button>

        <h3 class="stepper-header__title">
          {{ selected?.label }}
        </h3>
      </div>

      <div class="stepper-header__bottom">
        <div class="stepper-marker">
          <ul class="stepper-markers__list">
            <li
              class="stepper-markers__item"
              *ngFor="let step of steps; let i = index"
              [class.stepper-markers__item--completed]="selectedIndex >= i"
              [class.stepper-markers__item--active]="selectedIndex === i"
            >
              <button class="stepper-markers__button" (click)="step.select()">
                {{ i + 1 }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>

  <div class="stepper__content">
    <ng-container [ngTemplateOutlet]="selected ? selected.content : null">
    </ng-container>
  </div>
</section>
